import { render } from "./HowToRateLimit.vue?vue&type=template&id=aac88f76"
import script from "./HowToRateLimit.vue?vue&type=script&lang=js"
export * from "./HowToRateLimit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__